import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { filterAllBookingDates } from '../Purchase/BookingSystem';
import { filterTimeSlots } from '@frontend-components/features/Basket/components/TimeBooking/TimeBooking.utils';
function AdviceTimes({ bookingDates, selectedDate, selectedStartTime, setSelectedStartTime }) {
    const availableTimes = bookingDates.length === 0 || selectedDate == null ? [] : filterAllBookingDates(bookingDates, selectedDate);
    if (availableTimes.length === 0) {
        return null;
    }
    return (_jsx("div", Object.assign({ className: 'calendar-time grid grid-cols-2 lg:grid-cols-3 gap-3 font-normal xs:text-sm text-base overflow-auto h-full p-1' }, { children: filterTimeSlots(availableTimes).map((time, key) => (_jsx("span", Object.assign({ className: `flex items-center justify-center bg-white shadow-small normal rounded-sm cursor-pointer py-1 ${timeIsActive(time) ? 'active' : ''}`, onClick: () => setSelectedStartTime(time), "data-behat": 'booking-time' }, { children: getTime(time.start, time.end) }), `BOOKING_TIME_${key}`))) })));
    function timeIsActive(time) {
        return `${time.start}-${time.end}` === `${selectedStartTime === null || selectedStartTime === void 0 ? void 0 : selectedStartTime.start}-${selectedStartTime === null || selectedStartTime === void 0 ? void 0 : selectedStartTime.end}`;
    }
    function getTime(start, end) {
        const dateStart = new Date(start);
        const timeStart = dateStart.toLocaleTimeString('DK-dk', { hour: '2-digit', minute: '2-digit', timeZone: 'Etc/GMT-1' });
        const dateEnd = new Date(end);
        const timeEnd = dateEnd.toLocaleTimeString('DK-dk', { hour: '2-digit', minute: '2-digit', timeZone: 'Etc/GMT-1' });
        return `${timeStart} - ${timeEnd}`;
    }
}
AdviceTimes.propTypes = {
    bookingDates: PropTypes.array,
    selectedDate: PropTypes.instanceOf(Date),
    selectedStartTime: PropTypes.object,
    setSelectedStartTime: PropTypes.func
};
export default AdviceTimes;
